import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { InsuranceCompanyMySuffix } from 'src/app/shared/model/insurance-company-my-suffix.model';
import { InsuranceCompanyMySuffixService } from './insurance-company-my-suffix.service';
import { InsuranceCompanyMySuffixComponent } from './insurance-company-my-suffix.component';
import { InsuranceCompanyMySuffixDetailComponent } from './insurance-company-my-suffix-detail.component';
import { InsuranceCompanyMySuffixUpdateComponent } from './insurance-company-my-suffix-update.component';
import { InsuranceCompanyMySuffixDeletePopupComponent } from './insurance-company-my-suffix-delete-dialog.component';
import { IInsuranceCompanyMySuffix } from 'src/app/shared/model/insurance-company-my-suffix.model';
import { InsuranceCompanyMySuffixAccessPopupComponent } from './insurance-company-my-suffix-access-dialog.component';

@Injectable({ providedIn: 'root' })
export class InsuranceCompanyMySuffixResolve implements Resolve<IInsuranceCompanyMySuffix> {
    constructor(private service: InsuranceCompanyMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {


            if (state.url.includes('view')) {
                return this.service.view(id).map((insuranceCompany: HttpResponse<InsuranceCompanyMySuffix>) => insuranceCompany.body);
            } else {
                return this.service.find(id).map((insuranceCompany: HttpResponse<InsuranceCompanyMySuffix>) => insuranceCompany.body);
            }
        }
        return Observable.of(new InsuranceCompanyMySuffix());
    }
}

export const insuranceCompanyRoute: Routes = [
    {
        path: 'insurance-company',
        component: InsuranceCompanyMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'InsuranceCompanies'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'insurance-company/:id/view',
        component: InsuranceCompanyMySuffixDetailComponent,
        resolve: {
            insuranceCompany: InsuranceCompanyMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'InsuranceCompanies'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'insurance-company/new',
        component: InsuranceCompanyMySuffixUpdateComponent,
        resolve: {
            insuranceCompany: InsuranceCompanyMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'InsuranceCompanies'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'insurance-company/:id/edit',
        component: InsuranceCompanyMySuffixUpdateComponent,
        resolve: {
            insuranceCompany: InsuranceCompanyMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'InsuranceCompanies'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const insuranceCompanyPopupRoute: Routes = [
    {
        path: 'insurance-company/:id/delete',
        component: InsuranceCompanyMySuffixDeletePopupComponent,
        resolve: {
            insuranceCompany: InsuranceCompanyMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'InsuranceCompanies'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'insurance-company/:id/access',
        component: InsuranceCompanyMySuffixAccessPopupComponent,
        resolve: {
            insuranceCompany: InsuranceCompanyMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'InsuranceCompanies'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];


